(() => {
  if (window.smallsmoreOCaseTechDetailsBound) return;
  window.smallsmoreOCaseTechDetailsBound = true;

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ocase-spec-toggle]');
    if (!toggle) return;

    const block = toggle.closest('[data-ocase-spec-block]');
    if (!block) return;

    const isExpanded = !block.classList.contains('is-expanded');
    block.classList.toggle('is-expanded', isExpanded);
    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    toggle.setAttribute('aria-label', isExpanded ? 'Show less technical details' : 'Show all technical details');
  });
})();
